import { Vue, Component, Prop, Emit, Watch, Ref } from 'vue-property-decorator'

import {
  ProductionPlan, WorkInProgressServiceProxy,
} from '@/service-proxies/app-v2/coproduction.service-proxies'
import dayjs from 'dayjs'
const wipsp = new WorkInProgressServiceProxy()

@Component({
  components:{
  }
})
export default class MaterialRequirementList extends Vue {
  // 物料需求清单
  @Prop({ default: null }) readonly plan: ProductionPlan

  planId = ''
  loading = false
  tableData = []
  get columns(){
    return [
    {
      title: this.$t('page_bom_no'),
      dataIndex: 'materialCode',
      key: 'materialCode',
      ellipsis: true
    },
    {
      title: this.$t('page_bom_name'),
      dataIndex: 'materialName',
      key: 'materialName',
      ellipsis: true
    },
    {
      title: this.$t('page_plan_order_no'),
      dataIndex: 'orderCode',
      key: 'orderCode',
      ellipsis: true
    },
    {
      title: this.$t('page_plan_delivery_no'),
      dataIndex: 'processCode',
      key: 'processCode',
      ellipsis: true
    },
    {
      title: this.$t('page_material_warehousing_area'),
      dataIndex: 'area',
      key: 'area',
      ellipsis: true
    },
    {
      title: this.$t('page_material_warehousing_location'),
      dataIndex: 'location',
      key: 'location',
      ellipsis: true
    },
    {
      title: this.$t('page_plan_delivery_quantity'),
      dataIndex: 'number',
      key: 'number',
      ellipsis: true
    }
  ]}

  @Watch('plan', { immediate: true, deep: true })
  handlePlanChange(val) {
    console.log('plan:', val)
    this.planId = val ? val.id : ''
    this.getTableData()
  }

  async getTableData() {
    if(this.planId){
      try {
        this.loading = true
        let res = await wipsp.wipStockOutRecordList(this.planId)
        console.log(res)
        this.tableData = res
      } catch (e) {

      }
      this.loading = false
    }
  }

  render() {
    return (
      <ml-table
        loading={this.loading}
        columns={this.columns}
        dataSource={this.tableData}
        size="small"
        rowKey="id"
        canChangeColWidth={true}
        pagination={false}
        scroll={{ y: 300 }}
        >
      </ml-table>
    )
  }
}
